import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Admin } from 'core/models/admin';

const initialState = null as Admin | null;

const adminSlice = createSlice({
	name: 'admin',
	initialState,
	reducers: {
		setAdmin: (_, action: PayloadAction<Admin>) => action.payload,
		clearAdmin: () => null,
		updateAdmin: (state, action: PayloadAction<Partial<Admin>>) => {
			if (state) {
				Object.assign(state, action.payload);
			}
		},
	},
});

export const { setAdmin, clearAdmin, updateAdmin } = adminSlice.actions;
export default adminSlice.reducer;
